import { createEffect } from 'effector'

import { store } from 'src/store'
import { clearStore } from 'src/store/slices/common'

export const clearStoreFx = createEffect(
  () => void store.dispatch(clearStore()),
)
